<template>
	<v-container>
		<div class="base-page">
			<v-row>
				<v-col align="center">
					<close-app-logo color="dark" />
					<div class="title-page font-weight-bold">{{ $t('IdentificationPage') }}</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-card-text>
						<h4 class="text-center">{{ $t('hello') }}</h4>
						<h3 class="text-center mt-5">{{ auth.name }}</h3>
						<h3 v-if="auth.provider !=='edu'" class="text-center mt-2">{{ auth.email }}</h3>
					</v-card-text>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="10">
					<v-btn block color="btnColor" rounded @click="doLogin">
						<span class="px-2 font-weight-bold text-h5">{{ $t("loginPage.continue") }}</span>
					</v-btn>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-btn text link :href="`/logout${search}`" color="primary">
					<div class="font-weight-bold text-h5">{{arentYouUsername }}</div></v-btn>
					</v-row>
					<lang-select />
				</div>
		</v-container>
</template>

<script>
import ProjectModule from "src/store/modules/Project.module";
import CloseAppLogo from "@/components/CloseAppLogo";
import UserModule from "src/store/modules/User.module";
import LangSelect from "@/components/LangSelect";


export default {
	components: {
		CloseAppLogo,
		LangSelect
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: ""
		},
		errors: {}
	}),
	computed: {
		auth() {
			return this.$store.state.AuthModule.user;
		},
		search() {
			return location.search;
		},
		complexMosad() {
			return JSON.parse(this.auth.edu_complex_mosad);
		},
		arentYouUsername() {
			return `${this.$t('arentYou')} ${this.auth.name}?`;
		}
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(ProjectModule.types.GET, id);
		}
		// this.setProjectBackgroundImage();
	},
	methods: {
		setProjectBackgroundImage() {
			document.querySelector(".background-image").style.background =
				"url(" + this.project.image + ")";
		},
		async doLogin() {
			window.location = "/oauth/authorize" + this.search;
		},
		async selectMosad(mosad) {
			await this.$store.dispatch(UserModule.types.SELECT_MOSAD, { id: this.auth.id, edu_mosad: mosad });
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.background-image {
	z-index: -1 !important;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	webkit-background-size: cover !important;
	-moz-background-size: cover !important;
	-o-background-size: cover !important;
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
	filter: blur(6px);
	-webkit-filter: blur(6px);
	transform: scale(1.03);
}

.page {
	width: 90%;
	margin: auto;
	background-color: $background;

	@include responsive($mobile) {
		max-width: $mobile !important;
		max-height: $mobile-height;
	}

	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}
</style>
